import {
  IRegistryInstitution,
  TRegistryInstitution
} from "../../model/RegistryInstitution";
import { IOrganisation } from "../../model/Organisation";

export interface TOrganisationPresentationModel extends IOrganisation {
  institutionName: string;
  institution: TRegistryInstitution;
}

const OrganisationPresentationModel = (
  data: IOrganisation,
  institution?: IRegistryInstitution
) => {
  const handler: ProxyHandler<IOrganisation> = {
    get: function (target, prop, receiver) {
      switch (prop) {
        case "institutionName":
          return institution?.name;
        case "institution":
          return institution;
        default:
          return Reflect.get(target, prop, receiver);
      }
    },
    set: function (target, prop, value, receiver) {
      switch (prop) {
        case "institutionName":
        case "institution":
          return true;
        default:
          return Reflect.set(target, prop, value, receiver);
      }
    }
  };
  return new Proxy<IOrganisation, TOrganisationPresentationModel>(
    data,
    handler
  );
};

export default OrganisationPresentationModel;
